import { Team, ArticleOrder, ArticleSort, ArticleVariant, TagsMatchMode, ImageObjectFit, CardSize } from '@repo/types';

export type ArticleListFormData = {
  title?: string;
  startDate?: string;
  endDate?: string;
  tags?: string;
  tagsMatchMode?: TagsMatchMode;
  teamFromSlug?: boolean;
  filterByTags?: boolean;
  readFiltersFromUrl?: boolean;
  excludeTags?: string;
  excludeIds?: string;
  withPagination?: boolean;
  lazyLoad?: boolean;
  page?: number;
  limit?: number;
  sort?: ArticleSort;
  order?: ArticleOrder;
  variant?: ArticleVariant;
  listVariant?: ArticleListVariant;
  imageObjectFit?: ImageObjectFit;
  showImage?: boolean;
  showAuthor?: boolean;
  showTag?: boolean;
  showDate?: boolean;
  showSummary?: boolean;
  columns?: number;
  /** Predefined card width; `auto` (default) keeps the `columns` grid. A named
   *  size lays out as many fixed-width cards as fit and overrides `columns`. */
  size?: CardSize;
};

export const ArticleListVariant = {
  Default: 'default',
  TwoColumnGrid: 'TwoColumnGrid',
} as const;
export type ArticleListVariant = (typeof ArticleListVariant)[keyof typeof ArticleListVariant];

export type ArticleListProps = ArticleListFormData & {
  extraData?: {
    team?: Team;
  };
  prioritize?: boolean;
  searchParams?: { [key: string]: string | string[] | undefined };
};
